
import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';
import { getList } from '../api/index';
import { List, NoticeBar } from 'vant';
Vue.use(List).use(NoticeBar);
@Component
export default class Olympic extends Vue {
  timer: string = '';
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  async created() {
    const myDate = new Date();
    this.timer = moment(myDate).format('YYYY－MM－D');
  }
  onLoad() {
    // 5520
    getList(this.page).then((res: any) => {
      this.list = res.data.splice(0, 10);
      this.finished = true;
    });
  }
  // endListData(res: any) {
  //   this.page = this.page + 1;
  //   if (!res.data || res.data.length === 0) {
  //     this.finished = true;
  //   } else {
  //     this.list = [...this.list, ...res.data];
  //   }
  //   this.loading = false;
  // }
}
